import React from 'react';
import { useTranslation } from 'react-i18next';
const TablePagination = ({tableStyles, totalPages, page, limit, onPageChange, onPageSizeChange }) => {
    const { t } = useTranslation();
    const tr = (key) => {
        return t(`pagination:${key}`);
    };
  
    return (
        <div className={tableStyles.paginationContainer}>
            <div className="flex items-center gap-2">
                <select
                    value={limit}
                    onChange={(e) => {
                        onPageSizeChange(Number(e.target.value));
                    }}
                    className={tableStyles.select}
                >
                    {[5, 10, 20, 30, 40, 50].map((pageSize) => (
                        <option key={pageSize} value={pageSize} className="text-sm">
                            {tr('show')} {pageSize}
                        </option>
                    ))}
                </select>

                {/* Page Info */}
                <span className={tableStyles.pageInfo}>
                    {tr('page')} {' '}
                    <strong>
                        {page} {tr('of')} {totalPages}
                    </strong>
                </span>
            </div>
            <div className="flex gap-2">
                <button className={tableStyles.button} onClick={() => onPageChange(page - 1)} disabled={page === 1}>
                    {tr('previous')}
                </button>
                <button className={tableStyles.button} onClick={() => onPageChange(page + 1)} disabled={page >= totalPages}>
                    {tr('next')}
                </button>
            </div>
        </div>
    );
};

export default TablePagination;
